module.exports = __webpack_public_path__ + "media/images/icon-arrow-ur-large@2x-84dfd7a11d54ef95bfe7afca2e8330e3.png";